export var IdEnvironment;
(function (IdEnvironment) {
    // Only used for running tests
    IdEnvironment["Test"] = "test";
    IdEnvironment["Development"] = "development";
    IdEnvironment["Integration"] = "integration";
    IdEnvironment["Staging"] = "staging";
    IdEnvironment["Production"] = "production";
})(IdEnvironment || (IdEnvironment = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdEnvironment.ts
// module id = 452
// module chunks = 3